
import { ArrowUp } from "lucide-react";
import { useDeck } from "./SectionDeck";
import Reveal from "./Reveal";
import styles from "./deck.module.css";

interface BackToTopProps {
  label?: string;
  delay?: number;
}

export default function BackToTop({
  label = "Back to the top",
  delay = 0.2,
}: BackToTopProps) {
  const { goToSection } = useDeck();

  return (
    <Reveal dir="bottom" delay={delay}>
      <button
        type="button"
        className={styles.backToTop}
        onClick={() => goToSection(0)}
        aria-label={label}
      >
        <span className={styles.backToTopIcon}>
          <ArrowUp size={14} />
        </span>
        {label}
      </button>
    </Reveal>
  );
}
